import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

const filesExtraction = async (data, setProgress) => {
  let intervalId;
  try {
    setProgress(10);

    intervalId = setInterval(() => {
      setProgress(prev => Math.min(prev + 10, 80));
    }, 1000);

    const res = await axios.post(`/app/extract`, data);

    console.log(res);

    clearInterval(intervalId);
    setProgress(100);
    return res.data;
  } catch (error) {
    clearInterval(intervalId);
    throw error;
  }
};

export const useExtractFilesMutation = (id, { onMutate, setProgress, onError, onSuccess, onSettled } = {}) => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: data => filesExtraction(data, setProgress),
    onMutate: () => {
      onMutate && onMutate();
    },
    onError: error => {
      onError && onError(error);
    },
    onSuccess: async data => {
      await queryClient.invalidateQueries(['GET_PROJECT_FILE_DETAILS', id]);
      await queryClient.invalidateQueries(['GET_PROJECT_FILES', id]);
      await queryClient.invalidateQueries('credits');

      onSuccess && onSuccess(data);
    },
    onSettled: () => {
      onSettled && onSettled();
    }
  });

  return { mutate };
};
